import { useShallow } from "zustand/react/shallow";
import { type CallbackStore, useCallbackStore } from "./callback.store";
import { useSessionStore } from "./session.store";
import type { Session } from "./types";

export function getSelectedSession() {
    return useSessionStore.getState().computed.selectedSession() as unknown as Session;
}

export function getSelectedSessionId() {
    return useSessionStore.getState().computed.selectedSession().id;
}

export function getMostRecentTask({ currentTask, tasks }: Session) {
    const latestTask = Array.from(tasks.values()).at(-1);
    return currentTask ?? latestTask;
}

export function getSession(sessionId: string) {
    return useSessionStore.getState().getSession(sessionId);
}

export function getSessionByTaskId(taskId: string) {
    return useSessionStore.getState().getSessionByTaskId(taskId);
}

export function getSessionIdHistory(n?: number) {
    const history = getSessionHistory().map((item) => {
        return {
            sessionId: item.id,
            reason: item.metadata.startReason,
            timestamp: item.startedTimestamp,
        };
    });

    if (n && n < history.length) {
        const trimmedHistory = history.slice(Math.max(history.length - n, 0));
        return [...trimmedHistory];
    }

    return [...history];
}

export function getIsIdleSession() {
    return useSessionStore.getState().computed.isIdleSession();
}

export function getSessionHistory() {
    return useSessionStore.getState().sessions as unknown as Session[];
}

// TODO: This exists just to supply the UI with the direct access to what it should not be accessing directly.
// The UI logic that uses this should be moved to the SDK
export function useSetCallbackState() {
    return useCallbackStore(useShallow((state) => state.setCallback));
}

/** @deprecated this doesn't seem to be called anywhere and may not work as intended */
export function useClearCallbackState() {
    return useCallbackStore(useShallow((state) => state.clearCallback));
}

// TODO: This exists just to supply the UI with the direct access to what it should not be accessing directly.
// The UI logic that uses this should be moved to the SDK
export const setCallbackState = (...args: Parameters<CallbackStore["setCallback"]>) => {
    useCallbackStore.getState().setCallback(...args);
};

export const clearCallbackState = () => {
    useCallbackStore.getState().clearCallback();
};
